export const CRAWL_FETCH = "CRAWL_FETCH";
export const CRAWL_FETCHING = "CRAWL_FETCHING";
export const CRAWL_FULFILLED = "CRAWL_FULFILLED";
